
import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import Tooltip from '../../Tooltip';
import { getMultiLang, getSysFieldid } from '@platform/api';
import classnames from 'classnames';
require('./iconTitle.less');

export default function collection(Table) {
    return class HandleIcon extends Component {
        constructor(props) {
            super(props)
            this.state = {
                iconColumns: props.columns,
                data: props.data,
            }
        }

        UNSAFE_componentWillMount() {
            let callback = langJson => {
                this.setState({ langJson });
            };
            // moduleId为所需加载langJson文件夹名称前缀
            getMultiLang({ moduleId: 'base_table', callback });
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            // if (nextProps.columns != this.props.columns) {
            //     this.setState({
            //         iconColumns: nextProps.columns,
            //     })
            // }
            // if (nextProps.data !== this.props.data) {
            //     this.setState({
            //         data: nextProps.data,
            //         orderNum: nextProps.orderNum,
            //     })
            // }
            this.setState({
                iconColumns: nextProps.columns,
                data: nextProps.data,
            })
        }
        /**
        * 处理列头部信息
        * @param {*} columns 原始列头信息
        * @param {*} langJson 多语言
        * @returns 添加图标后的列头
        */
        createTitleIcon = (columns, langJson = {}) => {
            let nonLocationCodes = ['numberindex', 'opr', 'checkbox', 'blankrow', 'indexCol'];
            //  返回渲染列
            return columns.map(item => {
                // 递归处理子列头信息
                if (item.children) {
                    return {
                        ...item,
                        children: this.createTitleIcon(item.children, langJson),
                    };
                }
                if (nonLocationCodes.includes(item.attrcode || item.dataIndex)) {
                    return { ...item }
                } else {
                    let newItem = this.addIconInTitle(item, langJson);
                    // console.log(newItem)
                    return { ...newItem }
                }
            });
        }
        // 默认的比较函数,即字符串比较函数
        defaultSortFn = (key) => (a, b) => {
            let dataA = a[key] && a[key].value ? a[key].value : a[key];
            let dataB = b[key] && b[key].value ? b[key].value : b[key];
            return dataA >= dataB ? 1 : -1;
        }
        // 数值比较函数
        numberSortFn = (key) => (a, b) => {
            let dataA = a[key] && a[key].value ? a[key].value : a[key];
            let dataB = b[key] && b[key].value ? b[key].value : b[key];
            let numberA = parseFloat(dataA);
            let numberB = parseFloat(dataB);
            return numberA >= numberB ? 1 : -1;
        }

        // 中文比较函数，按拼音排序
        chineseSortFn = (key) => (a, b) => {
            let dataA = a[key] && a[key].value ? a[key].value : a[key];
            let dataB = b[key] && b[key].value ? b[key].value : b[key];
            return dataA.localeCompare(dataB, 'zh-Hans-CN', { sensitivity: 'accent' });
        }
        /**
         * 根据条件给表头添加图标，设置图标样式
         * @param {*} column 每一个列头信息
         * @returns 
         */
        addIconInTitle = (column, langJson) => {
            if (!column) {
                console.error('缺少列数据');
            }
            let { sortCallback } = this.props;
            let sortEle;
            // 设置图标样式，只有当sortFlag为true才显示图标
            let titleActiveClassName, activeUpIcon, activeDownIcon;
            if (column.order) {
                titleActiveClassName = 'show'
                if (column.order === "ascend") {
                    activeUpIcon = 'activeIcon'
                    activeDownIcon = ''
                } else if (column.order === "descend") {
                    activeUpIcon = ''
                    activeDownIcon = 'activeIcon'
                } else {
                    titleActiveClassName = activeUpIcon = activeDownIcon = ''
                }
            } else {
                titleActiveClassName = activeUpIcon = activeDownIcon = ''
            }
            // 设置定位图标
            let { allowLocation = true, attrcode, isSort = true } = column;
            //当配置sorter或isSort时，添加排序图标
            if (isSort) {
                if (isSort && !column.sorter) {
                    switch (column.fieldType) {
                        case 'number': {
                            column.sorter = this.numberSortFn(column.dataIndex);
                            break;
                        }
                        case 'stringChinese': {
                            column.sorter = this.chineseSortFn(column.dataIndex);
                            break;
                        }
                        default: {
                            column.sorter = this.defaultSortFn(column.dataIndex);
                            break;
                        }
                    }
                }
                // 设置排序图标
                sortEle = sortCallback && isSort &&
                    // <Tooltip
                    //     placement="top"
                    //     overlay={langJson['table_colseting_sort']}
                    //     className="column-icon-tooltip"
                    //     mouseLeaveDelay={0}
                    //     delayShow={300}>
                    <div className={`column-sort-container ${titleActiveClassName}`}>
                        <span className='column-sort-up'>
                            <i className={`iconfont th-sort icon-shangjiantou ${titleActiveClassName} ${activeUpIcon}`}
                                onClick={() => sortCallback(column, "ascend")} />
                        </span>
                        <span className='column-sort-down'>
                            <i className={`iconfont th-sort icon-xiajiantou ${titleActiveClassName} ${activeDownIcon}`}
                                onClick={() => sortCallback(column, "descend")} />
                        </span>
                    </div>
                // </Tooltip>
            }

            let { locationCallback, filterCallback,
                // 不允许过滤的列
                nonFilterable = ['numberindex', 'opr', 'checkbox'],
            } = this.props;
            let locationEle = locationCallback && allowLocation &&
                <Tooltip
                    placement="top"
                    overlay={langJson['table_location_des']}
                    className="column-icon-tooltip"
                    mouseLeaveDelay={0}
                    delayShow={300}
                >
                    <i
                        className={`iconfont th-sort icon-dingwei`}
                        onClick={() => locationCallback(column)}
                    />
                </Tooltip>
            // 过滤
            let filterEle = filterCallback && !nonFilterable.includes(attrcode) && <Fragment>
                {/* 是否筛选状态 */}
                {column.filterStatus !== 'filtered' && (
                    <Tooltip
                        placement="top"
                        overlay={langJson['table_location_filter']}
                        className="column-icon-tooltip"
                        mouseLeaveDelay={0}
                        delayShow={300}
                    >
                        <i
                            className="iconfont th-filter icon-sxuan"
                            onClick={() => {
                                filterCallback && filterCallback(column);
                            }}
                        />
                    </Tooltip>)
                }
                {/* 筛选出结果的状态 */}
                {column.filterStatus === 'filtered' && (
                    <Tooltip
                        placement="top"
                        overlay={langJson['table_location_filter']}
                        className="column-icon-tooltip"
                        mouseLeaveDelay={0}
                        delayShow={300}
                    >
                        <i
                            className="iconfont th-filter icon-lieguolv filtered"
                            onClick={e => {
                                /**
                                 * 点击筛选图标, 只有当前被筛选时,直接重置,
                                 * 还有其他列同时被筛选时, 去除当前列筛选条件重新筛选
                                 */
                                e.stopPropagation();
                                filterCallback && filterCallback(column, true);
                                // this.FilterPanelCallBack.current.handleHeaderOpen({ selectedAttr: attrcode });
                            }}
                        />
                    </Tooltip>
                )}
            </Fragment>
            // 整合列头信息   
            let title = <div
                className={
                    classnames({
                        'column-icon-title': true,
                        'title-align-right': column.itemtype === "number" || column.alignment === "right",
                        'title-align-left': column.alignment === "left",
                        'title-align-center': column.alignment === "center",
                    })}
                fieldid={getSysFieldid(column.attrcode)}
            >
                <span>
                    {column.title}
                    {((column.tooltips && column.showItemMsg !== false) ? (
                        <Tooltip
                            placement="top"
                            overlay={column.tooltips}
                        >
                            <span className='column-item-msg'>
                                <i className="iconfont icon-shuoming1 icon-msg-unhover" />
                                <i className="iconfont icon-shuoming2 icon-msg-hover " />
                            </span>

                        </Tooltip>
                    ) : null)}
                </span>

                <div className="column-icon-wrapper">
                    {sortEle}
                    <span>{column.orderNum}</span>
                    {filterEle}
                    {locationEle}
                    {column.customerIcon}
                </div>
            </div >
            return {
                ...column,
                title,
            }
        }
        render() {
            let {
                iconColumns,
                data,
                langJson,
            } = this.state
            let newIconColumns = this.createTitleIcon(iconColumns.concat(), langJson)
            return (
                <Table
                    {...this.props}
                    columns={newIconColumns}
                    data={data}
                />
            )
        }
    }
}